import { AttributeInputGenerator } from './AttributeInputGenerator'
import { FieldType, scope } from './AttributeColsMod'
import { dataType } from '../../../Typescript/StuartPy/StudyAttribute'
import { Stack } from '@mui/material'
import { stackGap } from '../../../Constants&Theme/Spacing'

function PrepareRenderInputs({
  fields,
  modalType,
  modalErrors,
  modalData,
  setModalErrors,
  setModalData,
  generateOptions,
}: {
  fields: FieldType[]
  modalType: scope | undefined
  modalData: any
  setModalData: any
  modalErrors: any
  setModalErrors: any
  generateOptions: any
}) {
  let filteredFields = fields.filter((col) =>
    modalType ? !col.hidden?.includes(modalType) : true,
  )

  //only show Formula for Endpoint and Calculation type
  if (
    ![dataType.Endpoint, dataType['Calculated Field']].includes(
      modalData?.AttrDatatype,
    )
  ) {
    filteredFields = filteredFields.filter((f) => f.field !== 'Formula')
  }

  //only show CodesetID and Options for Options type
  if (modalData?.AttrDatatype !== dataType.Options) {
    filteredFields = filteredFields.filter(
      (f) => !['AttrCodeSetID', 'options'].includes(f.field),
    )
  }

  return (
    <Stack
      gap={stackGap.col}
      sx={{ mt: 1 }}
    >
      {filteredFields.map((col) => (
        <AttributeInputGenerator
          key={col.field}
          field={col}
          data={modalData}
          setData={setModalData}
          errors={modalErrors}
          setErrors={setModalErrors}
          modalType={modalType}
          values={
            col.input === 'select' && generateOptions ?
              generateOptions(col.field)
            : undefined
          }
        />
      ))}
    </Stack>
  )
}

export default PrepareRenderInputs
